// MessageLikes.jsx
import { useSignal, useSignalEffect } from '@preact/signals';
import dislike from '/src/assets/dislike.svg';
import dislikeW from '/src/assets/dislikeW.svg';
import like from '/src/assets/like.svg';
import likeW from '/src/assets/likeW.svg';
import doubleLike from '/src/assets/doubleLike.svg';
import doubleLikeW from '/src/assets/doubleLikeW.svg';
import { useState } from 'preact/hooks';
import clsx from 'clsx';

async function updateMessageRating(id, score) {
  const path = `${import.meta.env.VITE_APP_API_URL}/api/v1/messages/${id}`;
  await fetch(path, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ score: score }),
  });
}

export default function MessageLikesChatbot({ id }) {
  const [isActiveDislike, setIsActiveDislike] = useState(false);
  const [isActiveLike, setIsActiveLike] = useState(false);
  const [isActiveLove, setIsActiveLove] = useState(false);

  function activeDislike() {
    const score = !isActiveDislike ? -1 : 0;
    updateMessageRating(id, score).then(() => {
      setIsActiveDislike(!isActiveDislike);
      setIsActiveLike(false);
      setIsActiveLove(false);
    });
  }

  function activeLike() {
    const score = !isActiveLike ? 1 : 0;
    updateMessageRating(id, score).then(() => {
      setIsActiveLike(!isActiveLike);
      setIsActiveDislike(false);
      setIsActiveLove(false);
    });
  }

  function activeLove() {
    const score = !isActiveLove ? 2 : 0;
    updateMessageRating(id, score).then(() => {
      setIsActiveLove(!isActiveLove);
      setIsActiveDislike(false);
      setIsActiveLike(false);
    });
  }

  return (
    <div className="bot-utn-likes">
      <div
        onClick={activeDislike}
        className={clsx({
          'bot-utn-likes-container-active': isActiveDislike,
          'bot-utn-likes-container': !isActiveDislike
        })}
      >
        <img
          className="bot-utn-likes-img"
          src={isActiveDislike ? dislikeW : dislike}
          alt="Icono de dislike"
        />
      </div>
      <div
        onClick={activeLike}
        className={clsx({
          'bot-utn-likes-container-active': isActiveLike,
          'bot-utn-likes-container': !isActiveLike
        })}
      >
        <img
          className="bot-utn-likes-img"
          src={isActiveLike ? likeW : like}
          alt="Icono de like"
        />
      </div>
      <div
        onClick={activeLove}
        className={clsx({
          'bot-utn-likes-container-active': isActiveLove,
          'bot-utn-likes-container': !isActiveLove
        })}
      >
        <img
          className="bot-utn-likes-img"
          src={isActiveLove ? doubleLikeW : doubleLike}
          alt="Icono de love"
        />
      </div>
    </div>
  );
}
